/**
*  Component - ToastMessage
*
*  @param {message} Any message to display
*  @param {type} Possible values: 'info', 'warning', 'error'
*
* Usage:
* <!-- <toast-message message="Hey" type="info" /> -->
* <!-- <toast-message message="Requires Minimum 8 characters" type="warning" /> -->
* <!-- <toast-message :message="errmsg" type="error" :isToastEnable="toast"  @close ="(val) => toast = val"/> -->
*
*/
<template>
<div>
  <div class="toast-msg" v-if="isToastEnable" :class="type">
    <span class="close" @click="close()" v-if="isClosed">X</span>
    {{ message }}
    <slot name="msgbtn">
    </slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'ToastMessage',
  props: {
    'message': {
      type: String
    },
    'type': {
      type: String
    },
    'isToastEnable': {
      type: Boolean,
      default: false
    },
    'isClosed': {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
    }
  },
  methods: {
      close(){
        this.$emit('close', false);
      }
  },
}
</script>

<style lang="scss">
.toast-msg {
   // border-radius: 4px;
   box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
   background-color: #ffffff;
   font-family: Montserrat;
   font-size: 14px;
   font-weight: normal;
   min-height: 45px;
   padding: 14px;
   color: #ffffff;
   // width: 300px;
   // height: auto;
   // position: fixed;
   // top: 10%;
   // z-index: 1;
   // right: 10px;
   // border-radius: 0px;
   .close{
     float: right;
     &:hover{
       cursor: pointer;
     }
   }
   &.info {
       color: #105ca4;
   }
   &.warning {
       color: #ab6c22;
   }
   &.error {
       color: #ab2222;
       font-weight: 600;
   }
}
</style>